import { useCallback, useEffect, useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { userSettingsStore } from '../../store/userSettingsStore';
import { applicationStore } from '../../store/applicationStore';
import {
  getBrowserDocumentHiddenProp,
  getBrowserVisibilityProp,
  getIsDocumentHidden,
} from '../../helpers/documentVisibility';
import { soundService } from '../../services';
import { isMobile } from '../../helpers/isMobile';
import { SoundTypes } from '../../services/baseSoundService/soundService';

const useUpdateEffect = (func, dep) => {
  const ref = useRef(false);
  useEffect(() => {
    if (ref.current) func();
    else ref.current = true;
    // eslint-disable-next-line
  }, dep);
};

export const SoundWatcher = observer(() => {
  const handleVisibilityChange = () => {
    if (!getIsDocumentHidden()) {
      soundService.pauseSounds();
    } else {
      soundService.resumeSounds();
    }
  };

  // useEffect(() => {
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
    return () => {
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  // const { isMusicOn, isSoundOn } = userSettingsStore;
  // const { isSoundsLoaded, isConnectionLost } = applicationStore;
  //
  // const [isVisible, setIsVisible] = useState(getIsDocumentHidden());
  //
  // const [isClickedDocument, setIsClickedDocument] = useState(false);
  //
  // const handleDocumentClick = useCallback(() => {
  //   setIsClickedDocument(true);
  //   // soundService.play(SoundTypes.BackgroundMusic);
  //   soundService.playMusic();
  //   document.removeEventListener('click', handleDocumentClick);
  // }, []);
  //
  // useEffect(() => {
  //   document.addEventListener('click', handleDocumentClick);
  //   return () => {
  //     document.removeEventListener('click', handleDocumentClick);
  //   };
  //   // eslint-disable-next-line
  // }, []);
  //
  // const playMusic = () => {
  //   if (isClickedDocument) {
  //     setIsClickedDocument(true);
  //   }
  //   document.removeEventListener('click', playMusic);
  // };
  //
  // useUpdateEffect(() => {
  //   soundService.muteMusic(true);
  //   soundService.muteSounds(true);
  //   soundService.muteMusic(!isMusicOn);
  //   soundService.muteSounds(!isSoundOn);
  //   // eslint-disable-next-line
  // }, [isSoundsLoaded]);
  //
  // useUpdateEffect(() => {
  //   document.addEventListener('click', playMusic);
  // }, [isMusicOn, isClickedDocument]);
  //
  // const muteMusicAndSounds = useCallback(() => {
  //   soundService.muteMusic(document[getBrowserDocumentHiddenProp()] ? true : !isMusicOn);
  //   if (isSoundOn) {
  //     soundService.muteSounds(document[getBrowserDocumentHiddenProp()] ? true : !isSoundOn);
  //   }
  // }, [isMusicOn, isSoundOn]);
  //
  // const onVisibilityChange = () => {
  //   if (isMobile()) {
  //     setIsVisible(getIsDocumentHidden());
  //   } else {
  //     muteMusicAndSounds();
  //   }
  // };
  //
  // useEffect(() => {
  //   return () => {
  //     soundService.stopAll();
  //     document.removeEventListener('click', playMusic);
  //   };
  //   // eslint-disable-next-line
  // }, []);
  //
  // useEffect(() => {
  //   const visibilityChange = getBrowserVisibilityProp();
  //   document.addEventListener(visibilityChange, onVisibilityChange, false);
  //   return () => {
  //     document.removeEventListener(visibilityChange, onVisibilityChange);
  //   };
  //   // eslint-disable-next-line
  // }, [isMusicOn, isSoundOn]);
  //
  // useEffect(() => {
  //   soundService.muteMusic(!isVisible || isConnectionLost ? true : !isMusicOn);
  //   soundService.muteSounds(!isVisible || isConnectionLost ? true : !isSoundOn);
  //   // eslint-disable-next-line
  // }, [isVisible, isConnectionLost]);
  //
  return null;
});
